export default () => ({
  formPanel: {
    maxWidth: 720,
  },
});



// WEBPACK FOOTER //
// ./src/components/Panels/FormPanel.styles.js